module.exports = __webpack_public_path__ + "static/media/dishes_and_silverware.f22d83e3.svg";